// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__9lnDF","paramInput":"JobSimulator_paramInput__1tJNh","input":"JobSimulator_input__1iHWe"};